import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProductBasic } from 'src/app/models/catalogs-model/product.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs/internal/observable/empty';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-products-dashboard',
  templateUrl: './catalogs-products-dashboard.component.html',
  styleUrls: ['./catalogs-products-dashboard.component.scss']
})
export class CatalogsProductsDashboardComponent implements OnInit, OnDestroy {

  productsList: ProductBasic[];
  getProductsListSubscription: Subscription;
  refreshProductsSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private snackbarService: SnackBarService,
              private productsService: ProductsService) {
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getProductsList();
    this.refreshProductsSubscription = this.productsService.refreshProductsListen().subscribe(
      (res) => {
        this.getProductsList();
      }
    );
  }

  private getProductsList() {
    this.getProductsListSubscription = this.productsService.getProductsList().pipe(
      tap((o: ProductBasic[]) => this.productsList = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-boxes', 'catalogs-page.products', '/catalog', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.products')]));
  }

  ngOnDestroy() {
    if (this.getProductsListSubscription) { this.getProductsListSubscription.unsubscribe(); }
    if (this.refreshProductsSubscription) { this.refreshProductsSubscription.unsubscribe(); }
  }
}
